import type { JSX } from "react";
import { cn } from "./cn";

export interface CheckboxProps {
  /** Whether the checkbox is checked */
  readonly checked?: boolean;
  /** Extra className */
  readonly className?: string;
  /** Click handler */
  readonly onClick?: () => void;
}

/**
 * A visual checkbox indicator. Supports optional onClick for interactivity.
 */
export function Checkbox({ checked, className, onClick }: CheckboxProps): JSX.Element {
  return (
    <div
      className={cn(
        "w-4 h-4 rounded border shrink-0",
        checked ? "bg-accent border-accent" : "border-edge",
        onClick && "cursor-pointer",
        className,
      )}
      role={onClick ? "checkbox" : undefined}
      aria-checked={onClick ? checked : undefined}
      onClick={onClick}
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onKeyDown={onClick ? (e) => { if (e.key === " " || e.key === "Enter") onClick(); } : undefined}
      tabIndex={onClick ? 0 : undefined}
    />
  );
}
